<forge-scaffold>
<app-bar slot="header" (menuBtnClicked)="handleMenuButtonClick()" *ngIf="(chromeless$ | async) === false"></app-bar>
 
  <forge-drawer [open]="isDrawerOpen" direction="left" slot="body-left" [attr.aria-hidden]="!isDrawerOpen"
    *ngIf="userService.hasInstanceAdminRole$ | async">
<aside>
    <forge-list navlist role="list" *ngIf="userService.hasGeneralAdminRole$ | async">
      <forge-list-item role="none" [selected]="isRouteActive('admin/site-branding-config')" ripple="true"
          [attr.aria-disabled]="!isDrawerOpen">
        <forge-icon name="color_lens" slot="start"></forge-icon>
        <a [routerLink]="['admin/site-branding-config']" [attr.tabindex]="isDrawerOpen ? 0 : -1">Site branding</a>
      </forge-list-item>
      <forge-list-item role="none" [selected]="isRouteActive('admin/search-visibility-config')" ripple="true"
          [attr.aria-disabled]="!isDrawerOpen">
        <forge-icon name="text_search" slot="start"></forge-icon>
        <a [routerLink]="['admin/search-visibility-config']" [attr.tabindex]="isDrawerOpen ? 0 : -1">Search settings</a>
      </forge-list-item>
      <forge-list-item role="none" [selected]="isRouteActive('admin/image-service-config')" ripple="true"
          [attr.aria-disabled]="!isDrawerOpen">
        <forge-icon name="settings" slot="start"></forge-icon>
        <a [routerLink]="['admin/image-service-config']" [attr.tabindex]="isDrawerOpen ? 0 : -1">Mugshot image
            service</a>
      </forge-list-item>
      <forge-list-item role="none" [selected]="isRouteActive('admin/alliance-service-config')" ripple="true"
          [attr.aria-disabled]="!isDrawerOpen">
        <forge-icon name="compare_arrows" slot="start"></forge-icon>
        <a [routerLink]="['admin/alliance-service-config']" [attr.tabindex]="isDrawerOpen ? 0 : -1">Alliance
            exchange</a>
      </forge-list-item>
    </forge-list>
</aside>
</forge-drawer>
<main slot="body" class="body-container">
<router-outlet *ngIf="!showErrorPage"></router-outlet>
<error-page-state *ngIf="showErrorPage" [backButtonEnabled]="errorRoutingState?.backButtonEnabled"
      [graphicSrc]="errorRoutingState?.graphicSrc" [message]="errorRoutingState?.message"
      [refreshButtonEnabled]="errorRoutingState?.refreshButtonEnabled" [title]="errorRoutingState?.title" />
</main>
<instance-footer slot="footer" *ngIf="(chromeless$ | async) === false"></instance-footer>
<forge-banner *ngIf="(outage$ | async)" [theme]="outageStatusService.bannerType" density="dense"
    style="position:sticky;top:0;z-index:2000;">
    {{ outageStatusService.outageMessage }}
</forge-banner>
</forge-scaffold>